import Vue from 'vue'
import injector from 'vue-inject'
import moment from 'moment'
Vue.use(injector)

class Datetime {
    /**
     * Convert date (string) from local to UTC
     * @param datetime
     * @returns {string}
     */
    localToUtc (datetime) {
        return moment.utc(moment(datetime)).format('YYYY-MM-DD')
    }

    /**
     * Convert date (string) from UTC to local
     * @param datetime
     * @returns {string}
     */
    utcToLocal (datetime) {
        return moment.utc(datetime).local().format('YYYY-MM-DD')
    }
}

injector.service('datetime', Datetime)


// WEBPACK FOOTER //
// ./src/services/datetime.js